import { createSelector } from 'react-sweet-state';

import type { ModifiedFieldValues } from '../../../../common/types/form/form-fields/field-values';
import type { FormRendererState } from '../../types';

export const hasModifiedValuesSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	void,
	boolean
> = createSelector(
	(state: FormRendererState) => state.modifiedValues,
	(modifiedValues: ModifiedFieldValues) => Object.keys(modifiedValues).length > 0,
);
